module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-exclusives-9116fc8daf5133da933e6851acad197a.png";